import { defineMessages } from '@jutro/locale';

export default defineMessages({
    bundledDocuments: {
        id: 'ml.gateway.documents.BUNDLED DOCUMENTS',
        defaultMessage: 'BUNDLED DOCUMENTS'
    },
    policyDocuments: {
        id: 'ml.gateway.documents.POLICY DOCUMENTS',
        defaultMessage: 'POLICY DOCUMENTS'
    },
    billingDocuments: {
        id: 'ml.gateway.documents.BILLING DOCUMENTS',
        defaultMessage: 'BILLING DOCUMENTS'
    },
    documentsSentUs: {
        id: 'ml.gateway.documents.DOCUMENTS YOU SENT US',
        defaultMessage: 'DOCUMENTS YOU SENT US'
    },
    actionRequired: {
        id: 'ml.gateway.documents.ACTION REQUIRED',
        defaultMessage: 'ACTION REQUIRED'
    },
    idCards: {
        id: 'ml.gateway.documents.ID CARDS',
        defaultMessage: 'ID CARDS'
    },
    shareSelectedDocuments: {
        id: 'ml.gateway.documents.Share Selected Documents',
        defaultMessage:'Share Selected Documents'
    },
    shareDocuments: {
        id: 'ml.gateway.documents.Share Documents',
        defaultMessage:'Share Documents'
    },
    chooseShareDocument: {
        id: 'ml.gateway.documents.Choose how you want to share your document',
        defaultMessage: 'Choose how you want to share your document'
    },
    emailAddress: {
        id: 'ml.gateway.documents.Email Address',
        defaultMessage: 'Email Address'
    },
    fax: {
        id: 'ml.gateway.documents.Fax',
        defaultMessage: 'Fax'
    },
    docsWillBeMailed: {
        id: 'ml.gateway.documents.Documents will be mailed',
        defaultMessage: 'Documents will be mailed to the mailing address associated with your policy'
    },
    sharingDocuments: {
        id: 'ml.gateway.account.documents.Sharing documents',
        defaultMessage: 'Sharing documents'
    },
    emailSubTypeNotAllowed: {
        id: 'ml.gateway.policies.documents.Email delivery is not available for one or more of the documents chosen.  You may only select email delivery for the following: Quote proposals, signature forms, ID cards, and evidence/certificate of insurance',
        defaultMessage: 'Email delivery is not available for one or more of the documents chosen.  You may only select email delivery for the following: Quote proposals, signature forms, ID cards, and evidence/certificate of insurance.'
    },
    tooManyDocsToEmailOrFax: {
        id: 'ml.gateway.policies.documents.Email and Fax delivery are not available.  You may only share four documents via email or fax at a time',
        defaultMessage: 'Email and Fax delivery are not available.  You may only share four documents via email or fax at a time.'
    },
    emailSubTypeNotAllowedAndTooManyToEmailOrFax: {
        id: 'ml.gateway.policies.documents.Email and Fax delivery are not available.  You may only share four documents via email or fax at a time and may only select email delivery for the following: Quote proposals, signature forms, ID cards, and evidence/certificate of insurance.',
        defaultMessage: 'Email and Fax delivery are not available.  You may only share four documents via email or fax at a time and may only select email delivery for the following: Quote proposals, signature forms, ID cards, and evidence/certificate of insurance.'
    }
});